<template>
  <section>
    <div class="standardItem1">
      <div>{{ obj.article_name }}</div>
      <div>
        <span v-for="(item, index) in list" :key="index">
          {{ item.label }}{{ obj[item.model] }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "comDtoData1",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {},
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleRoute(v, x) {
      if (v == 5) {
        this.$router.push(x);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.standardItem1 {
  display: flex;
  flex-direction: column;
  height: 100%;
  > div {
    width: 100%;
    &:nth-child(1) {
      font-family: "Microsoft YaHei";
      color: #555;
      font-size: 20px;
      font-weight: bolder;
      height: 36%;
    }
    &:nth-child(2) {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      > span {
        font-family: "Microsoft YaHei";
        font-size: 12px;
        color: #888;
        line-height: 24px;
        margin-right: 22px;
      }
    }
  }
}
</style>